import { destroy2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useInternalNotificationsDelete = () => {
  const branchId = useBranchId();

  const { t } = useTranslation();

  const mutation = useMutation({
    mutationFn: ({ itemId }: { itemId: number }) =>
      destroy2(
        `/internal/secure/pos/v1/internal/notifications/${branchId}/${itemId}`
      ),
    onSuccess: () => {
      toast.success(t("success.delete"));
    },
  });

  return mutation;
};

export default useInternalNotificationsDelete;
